export default __webpack_public_path__ + "static/media/E686545F-1028-4A04-8301-609755182BED_1_105_c.b8584eac.jpeg";